import gql from 'graphql-tag';
import { PROJECT_POST_FIELDS } from '@/store/projectPostFragment';

/**
 * Data of the block project-posts ("Nachrichten"): the posts of the project, oldest first. Read
 * through `Project.blocks.posts`, which checks the block's read permission.
 */
export const PROJECT_POSTS_FIELDS = gql`
  fragment projectPostsFields on ProjectPostsBlock {
    id
    number
    posts {
      ...projectPostFields
    }
  }
  ${PROJECT_POST_FIELDS}
`;
